import { ThemeContext } from '@hb/react'
import { Field } from '@hb/shared'
import { useContext, useMemo } from 'react'
import { FieldRenderProps } from 'react-final-form'

// Input design tokens — Charting UI Visual Design System (spec Section 0.6).
// All text inputs/textareas use a crisp 0.5px border that turns sage green on focus.
export const inputBorderColor = '#cccccc'
export const inputFocusBorderColor = '#4a7c59'
export const inputErrorBorderColor = '#c0392b'

// Border color for an input's current state: sage green while focused, red when showing a
// validation error, neutral gray otherwise. The bordered look is scoped to the `detailed`
// theme — `basic`-theme inputs (inline / DataView edit surfaces) stay borderless via a
// transparent border, preserving layout without a visible box.
export const useStatusBorderColor = (field: Field, meta: FieldRenderProps['meta']) => {
  const { error, touched, active } = meta ?? {}
  const { theme } = useContext(ThemeContext)
  return useMemo(() => {
    if (theme === 'basic') return 'transparent'
    if (active) return inputFocusBorderColor
    if (error && touched) return inputErrorBorderColor
    return inputBorderColor
  }, [theme, error, touched, active])
}
